import React, { Component } from "react";

export default class LoginPage extends Component {
  render() {
    return (
      <div>
        <h1>Hello from Login page</h1>
      </div>
    );
  }
}
